import React, { FunctionComponent } from 'react';
import ThreeDLayout from "./3DLayout";

interface OwnProps {}

type Props = OwnProps;

const BaseScene: FunctionComponent<Props> = (props) => {

    return (
        <ThreeDLayout/>
    );
};

export default BaseScene;
